import api from './api';
import API_ROUTES from './apiRoutes';
import { currentSeasonYear } from '../utils/season';

const teamService = {
  // Player team services
  getPlayerTeams: async (params = {}) => {
    const response = await api.get(API_ROUTES.AUTH.PLAYER_TEAMS(params));
    // Return full response with teams and pagination
    return response.data;
  },

  getTeamPlayers: async (teamId) => {
    const response = await api.get(API_ROUTES.AUTH.TEAM_PLAYERS(teamId));
    return response.data.players;
  },

  // Coach team services
  getCoachTeams: async (params = {}) => {
    const response = await api.get(API_ROUTES.COACH.TEAMS(params));
    return response.data;
  },

  getCoachTeamRoster: async (teamId, page = 1, limit = 20, seasonYear = currentSeasonYear(), filters = null, sortBy = null, sortOrder = null, statsType = null, category = null, scope = null) => {
    const response = await api.get(API_ROUTES.COACH.TEAM_ROSTER(teamId, page, limit, seasonYear, filters, sortBy, sortOrder, statsType, category, scope));
    return response.data;
  },

  // Scout team services
  getScoutGames: async (params = {}) => {
    const response = await api.get(API_ROUTES.SCOUT.GAMES(params));
    return response.data;
  },

  getScoutTeamRoster: async (teamId, page = 1, limit = 20, seasonYear = currentSeasonYear(), filters = null, sortBy = null, sortOrder = null, statsType = null, category = null, scope = null) => {
    const response = await api.get(API_ROUTES.SCOUT.TEAM_ROSTER(teamId, page, limit, seasonYear, filters, sortBy, sortOrder, statsType, category, scope));
    return response.data;
  },
};

export default teamService;
